import React from "react";
import {
  CartesianGrid,
  Legend,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import { Period } from "../types";
import { format } from "date-fns";
import en from "date-fns/locale/en";
import pl from "date-fns/locale/pl";
import Cookies from "js-cookie";

export const CustomTooltip = ({ active, payload, label }) => {
  if (active) {
    return (
      <div
        style={{
          border: "1px solid gray",
          backgroundColor: "rgba(255,255,255, 0.8)",
          padding: 10,
        }}
      >
        <p
          style={{
            color: "#000",
            textAlign: "center",
            fontSize: 15,
            marginBottom: 5,
          }}
        >
          {label}
        </p>
        {payload &&
          payload.map(data => (
            <p
              key={data.dataKey}
              style={{ margin: 0, fontSize: 13, color: data.color }}
            >
              {data.name} - {data.value} zł
            </p>
          ))}
      </div>
    );
  }

  return null;
};

const calculateChartPriceRange = allPrices => {
  const moneyRoundUp = num => Math.ceil(num / 10) * 10;
  const moneyRoundDown = num => Math.floor(num / 10) * 10;

  const maxPrice = Math.max(...allPrices);
  const minPrice = Math.min(...allPrices);
  const additionalPriceRange = Math.round(maxPrice / 10);
  const minPriceOnChart =
    moneyRoundDown(minPrice - additionalPriceRange) >= 0
      ? moneyRoundDown(minPrice - additionalPriceRange)
      : 0;
  const maxPriceOnChart = moneyRoundUp(maxPrice + additionalPriceRange);

  return [minPriceOnChart, maxPriceOnChart];
};
const formatDateToNumbers = (date, t = "D MMM", lang = "pl") =>
  format(date, t, { locale: lang === "pl" ? pl : en });

const Chart = ({ data, products, period }) => {
  const lang = Cookies.get("user_lang");

  const xAxisTickFormatter = name => {
    if (period === Period.weekly) {
      const from = name.split("-")[0].slice(0, -1);
      const to = name.split("-")[1];
      const fromDate = new Date(
        from.split(".")[2],
        from.split(".")[1],
        from.split(".")[0]
      );
      const toDate = new Date(
        to.split(".")[2],
        to.split(".")[1],
        to.split(".")[0]
      );
      return `${formatDateToNumbers(
        fromDate,
        "D MMM",
        lang
      )} - ${formatDateToNumbers(toDate, "D MMM", lang)}`;
    }
    return name.substr(0, 3);
  };

  const allPrices = data
    .map(({ name, ...rest }) => Object.values(rest))
    .reduce((acc, curr) => acc.concat(curr), [])
    .filter(value => value !== null)
    .map(Number);

  const domain = calculateChartPriceRange(allPrices);

  return (
    <ResponsiveContainer width="100%" height={400}>
      <LineChart
        width={500}
        height={300}
        data={data}
        margin={{
          top: 5,
          right: 30,
          left: 20,
          bottom: 5,
        }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis tickFormatter={xAxisTickFormatter} dataKey="name" />
        <YAxis tickFormatter={value => `${value} zł`} domain={domain} />
        <Tooltip content={<CustomTooltip />} />
        <Legend />
        {products.map(product => (
          <Line
            key={product.key}
            dataKey={product.key}
            stroke={product.color}
          />
        ))}
      </LineChart>
    </ResponsiveContainer>
  );
};

export default Chart;
